import {
  MDSButton,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";

interface AutoStopRecordingModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

export function AutoStopRecordingModal({
  isOpen,
  onClose,
  title,
  message,
}: AutoStopRecordingModalProps) {
  return (
    <MDSModalDialog isOpen={isOpen} handleClose={onClose}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        {title}
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>{message}</MDSText>
      </MDSDialogTextContent>

      <div slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={onClose}>OK</MDSButton>
      </div>
    </MDSModalDialog>
  );
}
